import { ColumnsEdit } from "types/models/column-table-edit";
import React from "react";

const width = "25%";
const columns: ColumnsEdit = [
  {
    key: "1",
    dataIndex: "tenXetNghiem",
    width: "50%",
    title: "Tên xét nghiệm",
    align: "left",
    // render: (text, record: { children: [] }, index) => {
    //   const isParent = record.children;
    //   return (
    //     <span
    //       style={
    //         isParent ? { fontWeight: "bold", textDecoration: "underline" } : {}
    //       }
    //     >
    //       {text}
    //     </span>
    //   );
    // },
    // onCell: (_, index) => {
    //   return { colSpan: 4 };
    // },
  },
  {
    key: "2",
    dataIndex: "giaTri",
    width: "18%",
    title: "Kết quả xét nghiệm",
    align: "center",
    // onCell: (_, index) => {
    //   return { colSpan: 0 };
    // },
  },
  {
    key: "3",
    dataIndex: "giaTriBinhThuong",
    width: "18%",
    title: "Giá trị tham chiếu",
    align: "center",
    // onCell: (_, index) => {
    //   return { colSpan: 0 };
    // },
  },
  {
    key: "4",
    dataIndex: "donViTinh",
    width: "14%",
    title: "Đơn vị",
    align: "left",
    // onCell: (_, index) => {
    //   return { colSpan: 0 };
    // },
  },
];

export { columns };
